module.exports = __webpack_public_path__ + "img/brodcast-exo-mobile.9ea45f30.jpg";